export default {
  namespaced: true,
  employees: {
    title: 'Empleados | Empleado',
    first_name: 'nombre',
    last_name: 'apellidos',
    employee_id: 'ID del empleado',
  }
}
